// Considered: StatusBadgeAtom — rejected because a pill in a dropdown's value slot breaks its height; this is glyph + word
// in the option row and the selected value, drawn with the glyph the badge uses. See spec Reuse Audit.
import React from 'react';
import { useTranslation } from 'localization';
import type { StatusValue } from 'types/spherePoints';
import { getLocalizedStatusLabel, getStatusValueIconClass } from '../../../utils/statusColors';
import './RollupGuardrailsSection.scss';

export interface RollupStatusOptionLabelProps {
  status: StatusValue;
}

const RollupStatusOptionLabel: React.FC<RollupStatusOptionLabelProps> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <span className="rollup-status-option" data-status={status}>
      <i className={`rollup-status-option__glyph ${getStatusValueIconClass(status)}`} aria-hidden="true" />
      <span>{getLocalizedStatusLabel(status, t as (key: string) => string)}</span>
    </span>
  );
};

RollupStatusOptionLabel.displayName = 'RollupStatusOptionLabel';

export default RollupStatusOptionLabel;
